import { render, staticRenderFns } from "./StcdR_Result_StockSummaryList.vue?vue&type=template&id=2c130f08"
import script from "./StcdR_Result_StockSummaryList.vue?vue&type=script&lang=js"
export * from "./StcdR_Result_StockSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports